import EventIcon from "@material-ui/icons/Event";
import React from "react";
import translate from "../../../i18n/translate";
import ErrorPage from "../../shared/ErrorPage/ErrorPage";
import "./MyScheduleSummaryBlock.scss";

const NoTrainerScenarioBlock = (props: any) => {

  const openProductPage = () => {
    if(!props.isUseravl)
    window.open(  process.env[`REACT_APP_PRODUCT_URL_ID_${props.productId}`] || "", "_self");
  };
  return (props.status !== 0 || !props.isCourseIdValid) ? (
    <React.Fragment> {<ErrorPage status={!props.isCourseIdValid? 300 : props.status} />}</React.Fragment>
  ) : (
    <div data-testid="schedule-container" className="ScheduleContainer" >
    <div className="ScheduleTitle">
      <h2>{translate("myschedule_schedule")}</h2>
    </div>
        <div className="session-main-container" id="session-list-not-available" onKeyDown={() => {}} onClick={openProductPage}>
          <a className="nosession-container" data-testid="avail-card" id="availCard_id">
            <div className="nosession-inner-container">
              <EventIcon fontSize="large"></EventIcon>
            </div>
            <div aria-label = "Schedule Information message"
            tabIndex={0}>
              {props.isUseravl && (
                <span className="availability-modify" data-testid="abty-given" id="abty_given">
                  {translate("myschedule_availability_abty_given")}
                </span>
              )}
              {!props.isUseravl && (
                <span className="availability-modify" data-testid="abty-not-given" id="abty_not_given" >
                  {translate("myschedule_availability_abty_not_given")}
                </span>
              )}
            </div>
          </a>
          <div className="availability-note">
            {!props.isUseravl &&
              <span data-testid="availability-note">*{translate("myschedule_availability_needAvl")}</span>
            }
          </div>
        </div>
      </div >
    );
};
export default NoTrainerScenarioBlock;
